export default "__VITE_ASSET__CG1r9EfK__"